import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

Vue.use(Vuex);

export default new Vuex.Store({

//  strict: true,  // turn on to see Errors and Warnings
  plugins: [vuexLocalStorage.plugin],
 
  state: {
    isConnected: false,
    socketMessage: '',
    auth: false,
    editingCarID: 0,
    activeWindowPartID: 0,
    activeAccountID: '',
    activeFolder: { id: null, cat_type: 'inbox' },
    searchQuery: '',
    draggedCar: false,    
    showUnreadOnly: false,
    showShareBox: false,
    accountContext:  {},
    currentRoute: ''
  },

  mutations:{

    SOCKET_CONNECT(state) {
      this.state.isConnected = true;
      console.log(state);
      console.log('state connected');


    },

    SOCKET_DISCONNECT(state) {
      state.isConnected = false;
      console.log(state);
      console.log('state disconnected');
      //state.auth = false;	  
      
    },
    
	updateEditingCarID: function (state, editingCarID) {		
      state.editingCarID = editingCarID;
    }    
    
  },
  

  actions: {
	  
    socket_messageChannel(context, message) {
	    console.log(message);
      context.state.socketMessage = message
	  //console.log(context);
    }
  }
})